import { use, useEffect } from "react";

import type {
  RevisionCallback,
  TranscriptContextValue,
} from "./transcript-context";
import { TranscriptContext } from "./transcript-context";

export function useTranscriptContext({
  onRevision,
}: {
  onRevision?: RevisionCallback;
} = {}): TranscriptContextValue {
  const context = use(TranscriptContext);
  const { registerRevisionCallback } = context;

  useEffect(() => {
    if (!onRevision) return undefined;
    return registerRevisionCallback(onRevision);
  }, [onRevision, registerRevisionCallback]);

  return context;
}
